import { Pipe, PipeTransform } from '@angular/core';

export type DateFormatType = 'date' | 'time' | 'datetime' | 'short' | 'long';

@Pipe({
  name: 'localeDate',
  standalone: true,
  pure: true,
})
export class LocaleDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined, format: DateFormatType = 'date'): string {
    if (!value) {
      return '';
    }

    const date = value instanceof Date ? value : new Date(value);

    if (isNaN(date.getTime())) {
      return '';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    switch (format) {
      case 'date':
        return `${year}-${month}-${day}`;
      case 'time':
        return `${hours}:${minutes}`;
      case 'datetime':
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      case 'short':
        return `${year}-${month}-${day}`;
      case 'long':
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      default:
        return `${year}-${month}-${day}`;
    }
  }
}
